import { getMappedPatientForSafe } from "@/module/overview/utils";
import { getMappedPatientForProvider } from "@/module/overview/utils";

export default {
  patientsTableDataForSafe(state) {
    const list = state.patientsTableDataForSafe.map((ele) => getMappedPatientForSafe(ele));
    return list;
  },
  patientsTableDataForProvider(state) {
    const list = state.patientsTableDataForProvider.map((ele) => getMappedPatientForProvider(ele));
    return list.reverse();
  },
  getFilterPatinetsTags(state) {
    if (!state.originalTableData) return [];
    var obj = {
      alif: 0,
      tlif: 0,
      v0_alif: 0,
      v0_tlif: 0,
    };

    Object.keys(state.originalTableData).forEach((providerKey) => {
      const patientsList = state.originalTableData[providerKey]
        ? state.originalTableData[providerKey].patient
        : [];

      patientsList.forEach((patient) => {
        if (typeof patient.tag === "object") {
          patient.tag.forEach((tag) => {
            obj[tag.id] = obj[tag.id] + 1;
          });
        }
      });
    });

    return Object.keys(obj).map((key) => {
      return {
        tag: key,
        count: obj[key],
      };
    });
  },
  patientTags(state) {
    if (!state.patientTags) return [];

    if (!state.selectedProvider) {
      var obj = {
        alif: 0,
        tlif: 0,
        v0_alif: 0,
        v0_tlif: 0,
      };

      Object.keys(state.patientTags).forEach((key) => {
        const currentObj = state.patientTags[key];

        Object.keys(currentObj).forEach((key) => {
          const tagObj = currentObj[key];
          obj[key] = obj[key] + tagObj.count;
        });
      });

      return Object.keys(obj).map((key) => {
        return {
          tag: key,
          count: obj[key],
        };
      });
    }

    var currentProviderId = state.selectedProvider;
    var currentTagsObj = state.patientTags[currentProviderId];
    if (!currentTagsObj) return [];
    return Object.keys(currentTagsObj).map((key) => ({
      tag: key,
      count: currentTagsObj[key].count,
    }));
  },
  allSites(state) {
    if (!state.providers) return [];
    return Object.keys(state.providers).map((key) => ({
      id: key,
      name: state.providers[key].name,
      count: state.providers[key].count,
      code: state.providers[key].code,
    }));
  },
  appointments(state) {
    if (!state.appointments) return [];

    if (!state.selectedProvider) {
      var obj = {
        today: 0,
        tomorrow: 0,
        week: 0,
      };

      Object.keys(state.appointments).forEach((key) => {
        const providerObj = state.appointments[key];

        Object.keys(providerObj).forEach((key) => {
          const appointmentObj = providerObj[key];
          obj[key] = obj[key] + appointmentObj;
        });
      });

      return [
        {
          label: "Today",
          value: obj.today,
        },
        {
          label: "Tomorrow",
          value: obj.tomorrow,
        },
        {
          label: "Next Week",
          value: obj.week,
        },
      ];
    }

    const currentProviderId = state.selectedProvider;
    const currentSite = state.appointments[currentProviderId];
    if (!currentSite) return [];
    return [
      {
        label: "Today",
        value: currentSite.today,
      },
      {
        label: "Tomorrow",
        value: currentSite.tomorrow,
      },
      {
        label: "Next Week",
        value: currentSite.week,
      },
    ];
  },
  totalPatients(state) {
    if (!state.patientTags) return 0;

    if (!state.selectedProvider) {
      return Object.keys(state.patientTags).reduce((acc, key) => {
        const tagsObj = state.patientTags[key];
        return Object.keys(tagsObj).reduce(
          (acc, key) => acc + tagsObj[key].count,
          0
        );
      }, 0);
    }

    const currentProviderId = state.selectedProvider;
    const currentSite = state.patientTags[currentProviderId];
    if (!currentSite) return 0;
    return Object.keys(currentSite).reduce(
      (acc, key) => acc + currentSite[key].count,
      0
    );
  },
};
